@let naytaKortinTila = naytaVirheet && !(ohitettuObservable | async);
<article class="block" [class.is-error]="naytaKortinTila && !!(onkoKorjattavaObservable | async)" [class.is-odottaa]="naytaKortinTila && !!(onkoOdottavaObservable | async)" [formGroup]="tosite.formGroup">
  <div class="block-fields">
    <div class="block-meta-row">
      <span class="badge">{{ 'tositteet.lisaa-tositteita.tosite-kortti.kuitti-prefix' | translate | async }} {{ jarjestysnumero }}</span>
      @if ((sivujenMaaraObservable | async) === 0) {
        <span class="filename">{{ 'tositteet.lisaa-tositteita.tosite-kortti.ei-tiedostoa' | translate | async }}</span>
      }
      <button type="button" class="icon-btn danger" (click)="poistaTosite.emit()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.poista-kuitti-aria' | translate | async">
        <span class="material-symbols-outlined" aria-hidden="true">delete_outline</span>
      </button>
    </div>

    @if (ohitettuObservable | async) {
      <div class="lahetysvirhe" role="status">
        <div class="ocr-status warn">
          <span class="material-symbols-outlined ico" aria-hidden="true">block</span>
          {{ 'tositteet.lisaa-tositteita.tosite-kortti.ohitettu' | translate | async }}
        </div>
        <div class="lahetysvirhe-napit">
          <button type="button" class="lahetysvirhe-nappi ensisijainen" (click)="yritaUudelleen.emit()">
            <span class="material-symbols-outlined" aria-hidden="true">refresh</span>
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.yrita-uudelleen' | translate | async }}
          </button>
        </div>
      </div>
    } @else if (kaikkiLatauksetEpaonnistuivatObservable | async) {
      <div class="lahetysvirhe" role="alert">
        <div class="ocr-status warn">
          <span class="material-symbols-outlined ico" aria-hidden="true">error_outline</span>
          {{ 'tositteet.lisaa-tositteita.tosite-kortti.lataus-epaonnistui' | translate | async }}
        </div>
        <div class="lahetysvirhe-napit">
          <button type="button" class="lahetysvirhe-nappi ensisijainen" (click)="yritaUudelleen.emit()">
            <span class="material-symbols-outlined" aria-hidden="true">refresh</span>
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.yrita-uudelleen' | translate | async }}
          </button>
          <button type="button" class="lahetysvirhe-nappi" (click)="ohitaLisays.emit()">
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.ohita-lisays' | translate | async }}
          </button>
        </div>
      </div>
    } @else {
      @if ((lukuTilaObservable | async) === 'taydennetaan') {
        <div class="ocr-status" role="status" aria-live="polite" aria-busy="true">
          <mat-spinner class="ico" diameter="16"></mat-spinner>
          {{ 'tositteet.lisaa-tositteita.tosite-kortti.ocr-taydennetaan' | translate | async }}
          <button type="button" class="ocr-cancel-small" (click)="keskeytaLuku.emit()" [attr.aria-label]="'tositteet.lisaa-tositteita.ocr-luenta.keskeyta-aria' | translate | async">
            {{ 'tositteet.lisaa-tositteita.ocr-luenta.keskeyta' | translate | async }}
          </button>
        </div>
      }

      @if ((epaonnistuneetIndeksitObservable | async)?.length; as epaonnistuneita) {
        <div class="sivun-lahetysvirhe" role="alert">
          <div class="ocr-status warn">
            <span class="material-symbols-outlined ico" aria-hidden="true">error_outline</span>
            @if (epaonnistuneita === 1) {
              {{ 'tositteet.lisaa-tositteita.tosite-kortti.sivun-lataus-epaonnistui-yksi' | translate | async }}
            } @else {
              {{ 'tositteet.lisaa-tositteita.tosite-kortti.sivun-lataus-epaonnistui-useita' | translate: { maara: epaonnistuneita } | async }}
            }
          </div>
          <div class="lahetysvirhe-napit">
            <button type="button" class="lahetysvirhe-nappi ensisijainen" (click)="yritaUudelleen.emit()">
              <span class="material-symbols-outlined" aria-hidden="true">refresh</span>
              {{ 'tositteet.lisaa-tositteita.tosite-kortti.yrita-uudelleen' | translate | async }}
            </button>
            <button type="button" class="lahetysvirhe-nappi" (click)="poistaEpaonnistuneet.emit()">
              {{ (epaonnistuneita === 1 ? 'tositteet.lisaa-tositteita.tosite-kortti.poista-epaonnistunut-yksi' : 'tositteet.lisaa-tositteita.tosite-kortti.poista-epaonnistunut-useita') | translate | async }}
            </button>
          </div>
        </div>
      } @else {
        @if ((lukuTilaObservable | async) === 'keskeytetty') {
          <div class="ocr-status" role="status" aria-live="polite">
            <span class="material-symbols-outlined ico" aria-hidden="true">info</span>
            @if (onkoLatausKeskenObservable | async) {
              {{ 'tositteet.lisaa-tositteita.tosite-kortti.ocr-keskeytetty-lahetetaan' | translate | async }}
            } @else {
              {{ 'tositteet.lisaa-tositteita.tosite-kortti.ocr-keskeytetty' | translate | async }}
            }
          </div>
        }

        @if ((lukuTilaObservable | async) === 'epaonnistui') {
          <div class="ocr-status warn" role="alert">
            <span class="material-symbols-outlined ico" aria-hidden="true">error_outline</span>
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.ocr-epaonnistui' | translate | async }}
          </div>
        }

        @if ((lukuTilaObservable | async) === 'lukukelvoton') {
          <div class="ocr-status warn" role="alert">
            <span class="material-symbols-outlined ico" aria-hidden="true">error_outline</span>
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.ocr-lukukelvoton' | translate | async }}
          </div>
        }

        @if (onkoPurkuvirheObservable | async) {
          <div class="ocr-status warn" role="alert">
            <span class="material-symbols-outlined ico" aria-hidden="true">error_outline</span>
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.purku-epaonnistui' | translate | async }}
          </div>
        }

        @if (naytaVirheet && (onkoLatausKeskenObservable | async) && (lukuTilaObservable | async) !== 'keskeytetty') {
          <div class="ocr-status" role="status" aria-live="polite">
            <span class="material-symbols-outlined ico" aria-hidden="true">schedule</span>
            {{ 'tositteet.lisaa-tositteita.tosite-kortti.lataus-kesken-odota' | translate | async }}
          </div>
        }
      }

      <div class="grid">
        @if ((lukuTilaObservable | async) === 'luetaan') {
          <div class="full">
            <app-ocr-luenta (keskeyta)="keskeytaLuku.emit()"></app-ocr-luenta>
          </div>
        } @else {
          @if (!lukittu) {
            <div class="full">
              <app-maksutapa-valinta [valittu]="tosite.formGroup.controls.maksutapa.value" [virhe]="annaMaksutapaVirhe()" [lukittu]="tosite.formGroup.controls.maksutapa.disabled" (valittuChange)="paivitaMaksutapa($event)"></app-maksutapa-valinta>
            </div>
          }

          <mat-form-field>
            <mat-label>{{ 'tositteet.lisaa-tositteita.tosite-kortti.maksupaiva-label' | translate | async }}</mat-label>
            <input numberDatePicker matInput type="text" formControlName="paivamaara" [matDatepicker]="datePicker" [errorStateMatcher]="virheidenNaytto" />
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
            @if (annaPaivamaaraVirhe(); as virhe) {
              <mat-error>{{ virhe | translate | async }}</mat-error>
            }
            @if (onkoVanhaPaiva()) {
              <mat-hint class="field-hint">
                <span class="material-symbols-outlined" aria-hidden="true">info</span>
                {{ 'tositteet.lisaa-tositteita.tosite-kortti.vanha-paiva-vihje' | translate | async }}
              </mat-hint>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'tositteet.lisaa-tositteita.tosite-kortti.summa-label' | translate | async }}</mat-label>
            <input decimalNumberField matInput type="text" inputmode="decimal" formControlName="summa" [errorStateMatcher]="virheidenNaytto" />
            <span matSuffix>€</span>
            @if (annaSummaVirhe(); as virhe) {
              <mat-error>{{ virhe | translate | async }}</mat-error>
            }
            @if (onkoHyvitys() || tosite.muuValuutta) {
              <mat-hint class="field-hint">
                <span class="material-symbols-outlined" aria-hidden="true">info</span>
                @if (onkoHyvitys()) {
                  <span>{{ 'tositteet.lisaa-tositteita.tosite-kortti.hyvitys-vihje' | translate | async }}</span>
                }
                @if (tosite.muuValuutta) {
                  <span>{{ 'tositteet.lisaa-tositteita.tosite-kortti.muu-valuutta-vihje' | translate | async }}</span>
                }
              </mat-hint>
            }
          </mat-form-field>

          <div class="full">
            <app-toimittaja-kentta [valittuNimi]="tosite.formGroup.controls.toimittajanNimi.value" [uusiToimittajaLomake]="tosite.formGroup.controls.uusiToimittaja" [tekoalynEhdotus]="tosite.uusiToimittajaTekoalylta" [virhe]="annaToimittajaVirhe()" (valittuNimiChange)="paivitaToimittajanNimi($event)" (valittuAvainChange)="paivitaToimittajaAvain($event)"></app-toimittaja-kentta>
          </div>

          @if (naytaProjektitObservable | async) {
            <div class="full">
              <app-projekti-kentta [valittuAvain]="tosite.formGroup.controls.projektiAvain.value" (valittuAvainChange)="paivitaProjektiAvain($event)"></app-projekti-kentta>
            </div>
          }

          @if (alvPortaat && alvPortaat.length > 0) {
            <mat-form-field class="full">
              <mat-label>{{ 'tositteet.lisaa-tositteita.tosite-kortti.alv-vahennysoikeus-label' | translate | async }}</mat-label>
              <mat-select formControlName="alvVahennysoikeus">
                @for (porras of alvPortaat; track porras) {
                  <mat-option [value]="porras">{{ porras }} %</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <mat-form-field class="full">
            <mat-label>{{ 'tositteet.lisaa-tositteita.tosite-kortti.lisatiedot-label' | translate | async }}</mat-label>
            <input matInput type="text" formControlName="lisatiedot" />
          </mat-form-field>
        }
      </div>
    }
  </div>

  <div class="block-image-col">
    <input #fileInput type="file" accept="image/*,application/pdf,.heic,.heif" multiple style="display: none" (change)="tiedostotMuuttui($event)" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.valitse-tiedosto-aria' | translate | async" />
    <div class="page-toolbar">
      <div class="pager">
        <button type="button" class="pg-btn" [disabled]="nykyinenSivuIndeksi === 0" (click)="edellinenSivu()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.edellinen-tiedosto-aria' | translate | async">
          <span class="material-symbols-outlined" aria-hidden="true">chevron_left</span>
        </button>
        <span class="pg-label">{{ 'tositteet.lisaa-tositteita.tosite-kortti.tiedosto-teksti' | translate | async }} {{ nykyinenSivuIndeksi + 1 }} / {{ sivujenMaaraObservable | async }}</span>
        <button type="button" class="pg-btn" [disabled]="nykyinenSivuIndeksi >= ((sivujenMaaraObservable | async) ?? 0) - 1" (click)="seuraavaSivu()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.seuraava-tiedosto-aria' | translate | async">
          <span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
        </button>
      </div>
      <div class="spacer"></div>
      @if (!(ohitettuObservable | async)) {
        <button type="button" class="add-page" (click)="avaaTiedostonValinta()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.lisaa-tiedosto-aria' | translate | async">
          <span class="material-symbols-outlined" aria-hidden="true">add</span>
          {{ 'tositteet.lisaa-tositteita.tosite-kortti.lisaa-tiedosto' | translate | async }}
        </button>
      }
    </div>

    @if (nykyinenSivuObservable | async; as sivu) {
      <div class="page-file">
        @if ((epaonnistuneetIndeksitObservable | async)?.includes(nykyinenSivuIndeksi)) {
          <span class="material-symbols-outlined page-virhe" [attr.title]="'tositteet.lisaa-tositteita.tosite-kortti.tiedoston-lataus-epaonnistui' | translate | async" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.tiedoston-lataus-epaonnistui' | translate | async" role="img">error_outline</span>
        }
        <span class="page-name">{{ sivu.alkuperainen?.nimi || ('tositteet.lisaa-tositteita.tosite-kortti.tiedosto-teksti' | translate | async) }}</span>
        @if (((sivujenMaaraObservable | async) ?? 0) > 1) {
          <button type="button" class="icon-btn-small" (click)="poistaSivuKlikattu(nykyinenSivuIndeksi, $event)" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.poista-tiedosto-aria' | translate | async">
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        }
      </div>
      @if (sivu.kuvaUrlit.length > 0) {
        <app-tiedoston-sivut [kuvaUrlit]="sivu.kuvaUrlit"></app-tiedoston-sivut>
      } @else {
        <div class="receipt-image" [class.is-clickable]="!!sivu.esikatselukuva" [attr.role]="sivu.esikatselukuva ? 'button' : null" [attr.tabindex]="sivu.esikatselukuva ? 0 : null" (click)="naytaSuurempana()" (keydown.enter)="naytaSuurempana()" [attr.aria-label]="sivu.esikatselukuva ? ('tositteet.lisaa-tositteita.tosite-kortti.nayta-suurempana-aria' | translate | async) : null">
          @if (sivu.esikatselukuva) {
            <img [src]="sivu.esikatselukuva" [alt]="$safeNavigationMigration(sivu.alkuperainen?.nimi)" />
            <span class="zoom-hint" aria-hidden="true">
              <span class="material-symbols-outlined">zoom_in</span>
            </span>
          }
        </div>
      }
    } @else {
      <div class="receipt-image"></div>
    }

    @if (onkoLatausKeskenObservable | async) {
      <div class="upload-bar" role="status" [attr.aria-label]="'tositteet.kasitellaan' | translate | async" [attr.title]="'tositteet.kasitellaan' | translate | async"></div>
    }
  </div>
</article>

@if (naytaModal) {
  <div class="image-modal" (click)="suljeModal()" (keydown.escape)="suljeModal()" tabindex="-1">
    <button type="button" class="modal-close" (click)="suljeModal()" [attr.aria-label]="'yhteiset.sulje' | translate | async">
      <span class="material-symbols-outlined" aria-hidden="true">close</span>
    </button>
    <div class="modal-content" (click)="$event.stopPropagation()">
      @if (nykyinenSivuObservable | async; as sivu) {
        <img [src]="sivu.esikatselukuva" [alt]="$safeNavigationMigration(sivu.alkuperainen?.nimi)" />
      }
    </div>
  </div>
}
